/* MFB Sticky cart bar — listens for Dawn's cart-update pub/sub events,
   refreshes count + total, toggles visibility based on item count.
   Falls back to /cart.js fetch when pub/sub isn't available. */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function refreshFromCart(cart) {
    var bar = $('MFBStickyCart');
    if (!bar) return;
    var count = (cart && cart.item_count) || 0;
    var total = (cart && cart.total_price) || 0;
    var countEl = bar.querySelector('[data-mfb-sticky-cart-count]');
    var totalEl = bar.querySelector('[data-mfb-sticky-cart-total]');
    if (countEl) countEl.textContent = count;
    if (totalEl) totalEl.textContent = formatMoney(total);
    bar.setAttribute('data-item-count', count);
    var label = bar.querySelector('.mfb-sticky-cart__count');
    if (label) {
      var unit = count === 1 ? 'item' : 'items';
      label.innerHTML = '<span data-mfb-sticky-cart-count>' + count + '</span> ' + unit;
    }
    if (count > 0) {
      bar.classList.add('mfb-sticky-cart--visible');
      document.body.classList.add('has-mfb-sticky-cart');
    } else {
      bar.classList.remove('mfb-sticky-cart--visible');
      document.body.classList.remove('has-mfb-sticky-cart');
    }
  }

  function fetchCartAndRefresh() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(refreshFromCart)
      .catch(function () {});
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = $('MFBStickyCart');
    if (!bar) return;
    var openBtn = bar.querySelector('[data-mfb-sticky-cart-open]');
    if (openBtn) openBtn.addEventListener('click', openCartDrawer);

    // Always re-fetch /cart.js on cartUpdate — the published cartData is the
    // added line-item response (no item_count / total_price), not the full cart.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartAndRefresh);
      } catch (e) {
        fetchCartAndRefresh();
      }
    }

    // Also refresh on form submission (covers product-form add to cart)
    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        setTimeout(fetchCartAndRefresh, 400);
      }
    });

    // Refresh when page becomes visible (e.g. user returns from checkout)
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') fetchCartAndRefresh();
    });
  });
})();
